import { render, staticRenderFns } from "./BaseFilesViewer.vue?vue&type=template&id=0ea9226c&scoped=true"
import script from "./BaseFilesViewer.vue?vue&type=script&lang=js"
export * from "./BaseFilesViewer.vue?vue&type=script&lang=js"
import style0 from "./BaseFilesViewer.vue?vue&type=style&index=0&id=0ea9226c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea9226c",
  null
  
)

export default component.exports